export const regexPatterns: Record<string, RegExp> = {
    slug: /^[\p{Ll}\p{Lo}\d/-]*\/$/u,
    fleetSize: /^[\d+]+$/,
    requireHttpHttps: /^(http|https):\/\//,
    externalUrl: /^(https?|ftp):\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?[^\s]*$/,
};

export const regexErrorMessages: Record<string, string> = {
    slug: 'The URL Slug may only contain lowercase letters, numbers, slashes or dashes, and must end with a trailing forward slash.',
    fleetSize: 'The fleet size should contain numbers and + sign only',
    linkedInLink: 'LinkedIn link needs to start with http:// or https://',
    twitterLink: 'Twitter link needs to start with http:// or https://',
    facebookLink: 'Facebook link needs to start with http:// or https://',
    instagramLink: 'Instagram link needs to start with http:// or https://',
    externalUrl: 'Please enter a valid URL.',
};
